<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-pie-chart"></span> B类用户
            </span>
        </div>
        <div v-if="data" class="content">
            <el-row :gutter="20" class="auditTotalNum">
                <el-col :sm="12" :md="6">
                    <el-card shadow="never">
                        <router-link to="/user/userAuth/list?claimStatus=1">
                            <div class="title">认证审核</div>
                            <div class="num clearfix">
                                <b>{{data.auditTotalNum.rzTotalNum || 0}}</b> 当前待处理
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="6">
                    <el-card shadow="never">
                        <router-link to="/user/userClaim/list?claimStatus=1">
                            <div class="title">认领审核</div>
                            <div class="num clearfix">
                                <b>{{data.auditTotalNum.rlTotalNum || 0}}</b> 当前待处理
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="6">
                    <el-card shadow="never">
                        <router-link to="/finance/activity/receivables/audit/list?status=1">
                            <div class="title">演出收款信息审核</div>
                            <div class="num clearfix">
                                <b>{{data.auditTotalNum.activityReceivablesTotalNum || 0}}</b> 当前待处理
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
                <el-col :sm="12" :md="6">
                    <el-card shadow="never">
                        <router-link to="/finance/raise/receivables/audit/list?status=1">
                            <div class="title">众筹收款信息审核</div>
                            <div class="num clearfix">
                                <b>{{data.auditTotalNum.raiseReceivablesTotalNum || 0}}</b> 当前待处理
                                <span class="el-icon-right fr"></span>
                            </div>
                        </router-link>
                    </el-card>
                </el-col>
            </el-row>

            <el-tabs v-model="activeName"  @tab-click="clickTab" class="MT10">
                <el-tab-pane label="新增" name="1"></el-tab-pane>
                <el-tab-pane label="认领" name="2"></el-tab-pane>
            </el-tabs>
            <div class="total">
                {{activeName == 1 ? '新增' : '认领'}}: <b>{{data.totalNumSum}} </b> 
            </div>
            <el-row :gutter="20" class="categoryDataList">
                <el-col :sm="8" v-for="(item,index) in data.categoryDataList" :key="index">
                    <router-link class="category-item" :to="`${item.category == 2 ? '/user/artist/list' : item.category == 3 ? '/user/site/list' : '/user/brand/list'}?startTime=${intervalData.startTime} 00:00:00&endTime=${intervalData.endTime} 23:59:59`">
                        <div class="logo" :class="`category-${item.category}-logo`"><el-image :src="userType.find( v => item.category == v.type ).logo"></el-image></div>
                        <div class="info">
                            <div class="num">
                                {{userType.find( v => item.category == v.type ).name}}{{activeName == 1 ? '新增' : '认领'}}:  {{item.totalNum}}
                            </div>
                            <div class="ratio color-info">
                                环比: 
                                <span v-if="item.totalNumRingRatio.type == 1" class="color-success"><span class="el-icon-top"></span> {{item.totalNumRingRatio.value}}</span>
                                <span v-else class="color-danger"><span class="el-icon-bottom"></span> {{item.totalNumRingRatio.value}}</span>
                            </div>
                            <div class="avg color-info">日均: {{item.avgTotalNum}}</div>
                        </div>
                        <span class="el-icon-right"></span>
                    </router-link>
                </el-col>
            </el-row>
            <el-row :gutter="20" class="totalNumChart MT10">
                <el-col :md="8">
                    <div id="bUserChart1" ref="bUserChart1"></div>
                </el-col>
                <el-col :md="16" >
                    <div id="bUserChart2" ref="bUserChart2"></div>
                </el-col>
            </el-row>
        </div>
    </el-card>
</template>

<script>
import artistLogo from '@/assets/img/dashboard/icon_artist.png';
import venueLogo from '@/assets/img/dashboard/icon_venue.png';
import hostLogo from '@/assets/img/dashboard/icon_host.png';
import { Chart } from '@antv/g2';


export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange:{
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,
            data: null,
            activeName: "1",
            chart1: null,
            chart2: null,
        }
    },
    computed:{
        userType() {
            return [
                {name: '艺人', type: 2, logo: artistLogo},
                {name: '场地', type: 3, logo: venueLogo},
                {name: '厂牌', type: 5, logo: hostLogo},
            ]
        },
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: this.activeName == 1 ? "/dashboard/newBUser" : "/dashboard/rlBUser",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                    category: this.userType.map(v => v.type)
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;

                        this.$nextTick(() => {
                            this.drawChart1();
                            this.drawChart2();
                        })
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        clickTab(){
            this.getData();
        },
        drawChart1(){
            if( this.chart1 ) this.chart1.destroy();
            let _data = [];
            _data = [...this.data.totalNumChart.pieSeriesData];
            _data.map( v => {
                v.percent = parseFloat((v.value / this.data.totalNumSum).toFixed(4));
            })

            _data = _data.filter( v => v.value > 0 );
            
            this.chart1 = new Chart({
                container: 'bUserChart1',
                autoFit: true,
                height: 420,
            });

            this.chart1.coordinate('theta', {
                radius: 0.8,
            });

            this.chart1.data(_data);

            this.chart1.scale('percent', {
                formatter: (val) => {
                    val = (val * 100).toFixed(2) + '%';
                    return val;
                },
            });

            this.chart1.tooltip({
                showTitle: false,
                showMarkers: false,
            });

            this.chart1.legend('name', {
                position: 'top',
            });
            
            this.chart1
                .interval()
                .adjust('stack')
                .position('percent')
                .color('name')
                .label('percent', (val) => {
                    return {
                        content: (obj) => {
                            return obj.name //+ ':' + (obj.percent * 100).toFixed(2) + '%';
                        },
                    };
                })
                .tooltip('name*value*percent', (name, value, percent) => {
                    percent = (percent * 100).toFixed(2) + '%';
                    return {
                        name: name,
                        value: value+'('+percent+')',
                    };
                });

            this.chart1.render();

        },
        drawChart2(){
            if( this.chart2 ) this.chart2.destroy();
            let _data = [];
            const _dataArry = [...this.data.totalNumChart.lineSeriesData];

            _dataArry.map( item => {
                item.value.map( v => {
                    _data.push({
                        name: item.name,
                        year: v.name,
                        value: parseFloat(v.value)
                    })
                })
            })
            
            this.chart2 = new Chart({
                container: 'bUserChart2',
                autoFit: true,
                height: 420,
            });
            this.chart2.data(_data);

            if( this.data.totalNumChart.lineSeriesData[0].value.length > 7 ){
                this.chart2.option('slider', {
                    start: (this.data.totalNumChart.lineSeriesData[0].value.length - 7 ) / this.data.totalNumChart.lineSeriesData[0].value.length,
                    end: 1,
                });
            }

            this.chart2.tooltip({
                showCrosshairs: true,
                shared: true,
            });
            this.chart2.legend('name', {
                position: 'top',
            });
            this.chart2
                .line()
                .position('year*value')
                .color('name')
                .shape('smooth')
                .tooltip('name*value', (name, value) => {
                    // value = this.activeName == 1 ? parseFloat(value).toFixed(2) : value;
                    return {
                        name: name,
                        value: value,
                    };
                });

            this.chart2.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.total{
    margin:10px 0 15px 0;
    b{
        font-size: 18px;
        font-weight: 700;
    }
}
.auditTotalNum{
    .num{
        margin-top: 10px;
        color: $--color-info;
        b{
            font-weight: 700;
            font-size: 16px;
            color: $--color-theme;
        }
    }
}
.categoryDataList{
    .category-item{
        display: flex;
        align-items: center;
        margin: 10px 0;
        border: 1px #eee solid;
        padding: 10px;
        font-size: 12px;
        border-radius: 4px;
        .logo{
            margin-right: 10px;
            background: rgba(100,150,249,1);
            border-radius: 50%;
            padding: 12px;
            .el-image{
                width: 26px;
                height: 26px;
            }
            &.category-3-logo{
                background: rgba(99,218,171,1);
            }
            &.category-5-logo{
                background: rgba(102,119,153,1);
            }

        }
        .info{
            flex: 1;
            .num{
                font-size: 14px;
            }
        }
    }
}
</style>